import React from 'react';
import {
  CrossBtn,
  CustomFooter,
  DialogBox,
  DisplayFade,
  ModalBody,
  ModalContent,
  ModalCustomHeader,
  ModalFooter,
  ModalHeader,
  ModalWrapper,
} from '../styles';

type IProps = {
  blueHeader?: boolean;
  redHeader?: boolean;
  greenHeader?: boolean;
  headerBgColor?: string;
  showCrossButton?: boolean;
  onClose?: () => void;
  title?: string;
  showHeader?: boolean | true;
  headerClass?: string;
  customHeaderClass?: string;
  titleFontSize?: string;
  customHeaderContent?: string;
  CustomHeaderPadding?: string;
  customHeaderBgColor?: string;
  footerContent?: React.ReactNode;
  showFooter?: boolean | true;
  footerClass?: string;
  footerBackground?: string;
  footerHeight?: string;
  footerBorder?: string;
  footerPadding?: string;
  customfooterContent?: React.ReactNode;

  wrapperWidth?: string;
  showFade?: boolean;
  headerSubBar?: string;
  bodyHeight?: string;
  maxHeight?: string;
  scrollColor?: string;
  minHeight?: string;
  scrollable?: boolean;
  modalClass?: string;
  dialogClass?: string;
  contentClass?: string;
  bodyClass?: string;
  contentBackgroundColor?: string;
  bodyBackgroundColor?: string;
  bodyPadding?: string;
  dialogueTextAlign?: string;
  children: React.ReactNode;
};
class ModalComponent extends React.Component<IProps> {
  // Define default props
  static defaultProps = {
    showFooter: false,
    scrollable: true,
    showHeader: true,
    customHeaderContent: '',
    title: '',
    titleFontSize: '',
    footerBackground: '',
    footerHeight: '',
    footerBorder: '',
    footerPadding: '',
    wrapperWidth: '',
    bodyHeight: '',
    minHeight: '200px',
    maxHeight: '268px',
    onClose: () => {},
    modalClass: '',
    dialogClass: '',
    contentClass: '',
    contentBackgroundColor: '',
    bodyClass: '',
    footerClass: '',
    headerClass: '',
    customHeaderClass: '',
    blueHeader: true,
    redHeader: false,
    headerBgColor: '',
    showFade: true,
    showCrossButton: true,
    greenHeader: false,
    orangeHeader: false,
    CustomHeaderPadding: '',
    customHeaderBgColor: '',
    bodyBackgroundColor: '',
    bodyPadding: '',
    dialogueTextAlign: '',
    scrollColor: '',
    headerSubBar: '',
  };

  get bgColor() {
    const { blueHeader, greenHeader, redHeader } = this.props;

    if (blueHeader) {
      return '#556BB8';
    }
    if (greenHeader) return '#57AC2D';

    if (redHeader) {
      //want to change the color of the header, set it to true and set blueHeader to false
      return '#ff0000';
    }
    return '';
  }

  get crossButton() {
    const { headerBgColor, showCrossButton } = this.props;

    if (!showCrossButton) return null;

    return (
      <CrossBtn
        className="close-button"
        color={headerBgColor || this.bgColor}
        onClick={() => this.props?.onClose && this.props?.onClose()}
      >
        X
      </CrossBtn>
    );
  }
  get header() {
    const {
      title,
      headerBgColor,
      showHeader,
      headerClass,
      customHeaderClass,
      titleFontSize,
      customHeaderContent,
      CustomHeaderPadding,
      customHeaderBgColor,
    } = this.props;

    if (!showHeader) return <div>{this.crossButton}</div>;

    if (customHeaderContent)
      return (
        <ModalCustomHeader
          padding={CustomHeaderPadding}
          className={`${customHeaderClass}`}
          bgColor={customHeaderBgColor}
        >
          {this.crossButton}
          {customHeaderContent}
        </ModalCustomHeader>
      );

    return (
      <>
        <ModalHeader
          className={`${headerClass}`}
          headerColor={headerBgColor || this.bgColor}
          titleFontSize={titleFontSize}
        >
          {this.crossButton}
          <div className="header-title">{title}</div>
        </ModalHeader>
        {this.props.headerSubBar && <div className="header-sub-bar">{this.props.headerSubBar}</div>}
      </>
    );
  }

  get footer() {
    const { footerContent, showFooter, footerClass, footerBackground, footerHeight, footerBorder } = this.props;

    if (!showFooter) return null;

    return (
      <ModalFooter bgColor={footerBackground} height={footerHeight} border={footerBorder} className={footerClass}>
        {footerContent}
      </ModalFooter>
    );
  }
  get customFooter() {
    const { customfooterContent, showFooter } = this.props;

    if (!showFooter) return null;

    return <CustomFooter>{customfooterContent}</CustomFooter>;
  }
  render() {
    const {
      wrapperWidth,
      showFade,
      bodyHeight,
      maxHeight,
      minHeight,
      modalClass,
      dialogClass,
      contentClass,
      bodyClass,
      contentBackgroundColor,
      bodyBackgroundColor,
      bodyPadding,
      dialogueTextAlign,
      scrollColor,
    } = this.props;
    return (
      <div>
        {showFade && <DisplayFade />}
        <ModalWrapper className={modalClass} id="myModal">
          <DialogBox width={wrapperWidth} className={dialogClass} textAlign={dialogueTextAlign}>
            <ModalContent bgColor={contentBackgroundColor} className={contentClass}>
              {this.header}
              <ModalBody
                bodyPadding={bodyPadding}
                bgColor={bodyBackgroundColor}
                minHeight={minHeight}
                bodyHeight={bodyHeight}
                maxHeight={maxHeight}
                className={bodyClass}
                scrollColor={scrollColor}
                redHeader={this.props.redHeader}
                greenHeader={this.props.greenHeader}
              >
                {this.props.children}
              </ModalBody>
              {this.footer}
            </ModalContent>
          </DialogBox>
        </ModalWrapper>
      </div>
    );
  }
}

export default ModalComponent;
